<template>
    <div class="col-lg-9">
        <h4 class="text-7">Users</h4>

        <div class="bg-white rounded shadow-sm p-4">
            <form @submit.prevent="data.fetch()" class="row mb-4 align-items-center pr-3">
                <div class="col-lg-2">
                    <select @change="data.fetch()" v-model="data.filters.size" class="custom-select" required>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="input-group col-lg-4 ml-auto">
                    <div class="input-group-prepend"><span class="input-group-text bg-white"><i
                        class="fas fa-search"></i></span></div>
                    <input type="text" class="form-control" v-model="data.filters.search" placeholder="Search....">
                </div>
                <button @click.prevent="data.fetch()"
                        :class="['btn btn-primary btn-sm text-white px-3 shadow-none' , data.loading ? 'btn-loading' : '']">
                    <i class="fas fa-arrow-alt-circle-right"></i>
                </button>
                <router-link to="/business/users/create"
                             class="btn btn-primary btn-sm text-white px-3 shadow-none mw-400 ml-2"><i
                    class="fas fa-plus-circle mr-2"></i>New User
                </router-link>
            </form>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th class="text-right"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in data.content.data">
                        <th scope="row">#{{ row.id }}</th>
                        <td>{{ row.name }}</td>
                        <td>{{ row.last_name }}</td>
                        <td>{{ row.email }}</td>
                        <td>{{ row.phone }}</td>
                        <td class="text-right">
                            <router-link class="px-3" :to="`/business/users/${row.id}/edit`"><strong>View</strong>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="d-flex align-items-center mt-5">
                    <div class="mr-auto">Showing {{ data.content.data.length }} of {{ data.content.total }} Records</div>
                    <div>
                        <button @click="data.append()"
                                v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                                :class="['btn btn-sm btn-primary shadow-none' , data.loading ? 'btn-loading' : '']"><i
                            class="fas fa-arrow-circle-down mr-2"></i>Load More
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Data from "../../../core/data/Data";

export default {
    name: "Index",
    data() {
        return {
            data: new Data({
                url: "/business/users/list",
                prefix: "users"
            })
        };
    },
    mounted() {
        this.data.fetch()
    }
}
</script>

<style scoped>

</style>
